import { makeEntityScaffold } from '@classpass/saga-tools';
import fetch from '../../../universal-fetch';

const handleResponse = res => {
  if (res.status >= 200 && res.status < 300) {
    return res;
  }
  const error = new Error(res.statusText);
  error.code = res.status;
  throw error;
};

export const movementByAlias = makeEntityScaffold(
  'SAGA.FETCH.MOVEMENT_BY_ALIAS',
  alias => {
    if (__SERVER__) {
      const { getMovementByAlias } = require('../../../../server/handlers/fitness-library');
      return getMovementByAlias(alias);
    }

    return fetch(`/_fitlib/movements/${alias}`)
      .then(handleResponse)
      .then(res => res.json());
  },
  { defaultKey: 0 }
);

export const searchMovements = makeEntityScaffold(
  'SAGA.FETCH.SEARCH_MOVEMENTS',
  aliasList => {
    if (__SERVER__) {
      const { searchMovements: localSearchMovements } = require('../../../../server/handlers/fitness-library');
      return localSearchMovements(aliasList);
    }

    return fetch('/_fitlib/movements/search', {
      method: 'POST',
      body: JSON.stringify({ movements: aliasList }),
      headers: { 'Content-type': 'application/json' },
    })
      .then(handleResponse)
      .then(res => res.json());
  },
  { defaultKey: aliasList => aliasList.join('_') }
);
